import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment-timezone";
import SimpleTable from "../../../../../../components/SimpleTable";
import { useCompanyTimeFormat } from "../../../../../../utils/hooks/company";
import { renderUserName } from "../../../../../../utils/helpers/user";
import { cn } from "../../../../../../lib/utils";

const columnHelper = createColumnHelper();

function ResponseTable({ data }: any) {
    const { t } = useTranslation();
    const timeFormat = useCompanyTimeFormat();

    const columns = useMemo(() => [
        columnHelper.accessor("user", {
            header: t("user"),
            cell: ({ row: { original: { user } } }: any) => {
                return renderUserName(user);
            }
        }),
        columnHelper.accessor("startDate", {
            header: t("start-time"),
            cell: ({ row: { original } }: any) => {
                const startDate = original?.shift?.startDate;
                return startDate ? moment.parseZone(startDate).format(timeFormat) : "";
            }
        }),
        columnHelper.accessor("endDate", {
            header: t("end-time"),
            cell: ({ row: { original } }: any) => {
                const endDate = original?.shift?.endDate;
                return endDate ? moment.parseZone(endDate).format(timeFormat) : "";
            }
        }),
        columnHelper.accessor("message", {
            header: t("status"),
            cell: ({ row: { original: { message, status } } }: any) => {
                return (
                    <span
                        className={cn(
                            status ? "tw-text-green-700" : "tw-text-rose-500"
                        )}
                    >
                        {message}
                    </span>
                );
            }
        }),

    ], [timeFormat, t]);

    return (
        <SimpleTable
            enableRowSelection={false}
            data={data}
            columns={columns}
            footer={false}
            loading={undefined}
            getRowProps={undefined}
        />
    );
}

export default ResponseTable;
